module.exports = __webpack_public_path__ + "d6885cd5a9a6b6f0a5671d10ec71feb8.jpg";